import { render, staticRenderFns } from "./AdministracionPtiPlan.vue?vue&type=template&id=ca64511c"
import script from "./AdministracionPtiPlan.vue?vue&type=script&lang=js"
export * from "./AdministracionPtiPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports